import React, { Component } from "react";
import { Row, Col } from "antd";
import "../memberSearch/searchMember.css";
import ReactToPrint from "react-to-print";
import moment from "moment";

class PCPHistory extends Component {
  render() {
    return (
      <div className="p-2 pb-3">
        <Row className="pl-2 member-info-header">
          <Col span={4}>PCP Name </Col>
          <Col span={4}>Effective Date </Col>
          <Col span={4}>Termination Date </Col>
          <Col span={6}>PCP's Phone Number </Col>
          <Col span={6}>PCP's Address </Col>
        </Row>
        <hr></hr>
        {/* Calling the Api and binding the data */}
        {this.props.PCPHistoryInfo.map((item) => {
          return (
            <Row className="p-2 row-details mb-2">
              <Col span={4}>
                {item.pcpFirstName && item.pcpMiddleName && item.pcpLastName
                  ? item.pcpFirstName + item.pcpMiddleName + item.pcpLastName
                  : item.pcpFirstName && item.pcpLastName
                  ? item.pcpFirstName + item.pcpLastName
                  : item.pcpFirstName
                  ? item.pcpFirstName
                  : item.pcpLastName
                  ? item.pcpLastName
                  : "- - - -"}
              </Col>
              <Col span={4}>
                {item.effectiveFrom
                  ? moment(new Date(item.effectiveFrom)).format("MM/DD/YYYY")
                  : "- - - -"}{" "}
              </Col>
              <Col span={4}>
                {item.effectiveTo
                  ? moment(new Date(item.effectiveTo)).format("MM/DD/YYYY")
                  : "- - - -"}{" "}
              </Col>
              <Col span={6}>
                {item.phoneNumber ? item.phoneNumber : "- - - -"}{" "}
              </Col>
              <Col span={6}>
                {item.addressLine1 ? item.addressLine1 : "- - - -"}{" "}
              </Col>
            </Row>
          );
        })}
      </div>
    );
  }
}

export default PCPHistory;
